<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务器信息</span>
            <!--<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
          </div>
          <table width="100%" border="0" cellspacing="0" cellpadding="7" class="tableBasic">
            <tr>
              <th width="120" valign="top">JAVA 版本：</th>
              <td valign="top">JavaVersion
              </td>
              <th width="120" valign="top">JAVA 路径：</th>
              <td valign="top">JavaHome
              </td>
            </tr>
            <tr>
              <th valign="top">服务器操作系统：</th>
              <td valign="top">OsName
              </td>
              <th valign="top">操作系统版本：</th>
              <td valign="top">OsVersion
              </td>
            </tr>
            <tr>
              <th valign="top">Servlet信息：</th>
              <td valign="top">ServerInfo
              </td>
              <th valign="top">Servlet版本：</th>
              <td valign="top">ServerVersion
              </td>
            </tr>
            <tr>
              <th width="120" valign="top">MySQL版本：</th>
              <td valign="top">MysqlVersion
              </td>
              <td valign="top"></td>
              <td valign="top"></td>
            </tr>
          </table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>SEO设置</span>
          </div>
          <table width="100%" border="0" cellspacing="0" cellpadding="7" class="tableBasic">
            <tr>
              <th width="120"> 站点标题：</th>
              <td>Title
              </td>
            </tr>
            <tr>
              <th> 站点描述：</th>
              <td>Description
              </td>
            </tr>
            <tr>
              <th> 站点关键字：</th>
              <td>Keywords
              </td>
            </tr>
            <tr>
              <th> 门户站点：</th>
              <td><a target="_blank"
                     href="<%=SystemManage.getInstance().getSystemSetting().getWww() %>">Www
              </a>
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>网站基本信息</span>
            <!--<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
          </div>
          <table width="100%" border="0" cellspacing="0" cellpadding="7" class="tableBasic">
            <tr>
              <th width="120">系统名称：</th>
              <td>Name
              </td>
              <th width="100">系统版本：</th>
              <td>Version
              </td>
            </tr>

            <tr>
              <th>门户站点：</th>
              <td><a target="_blank"
                     href="<%=SystemManage.getInstance().getSystemSetting().getWww() %>">
                Www
              </a></td>
              <th>网站标题：</th>
              <td>Title
              </td>
            </tr>
            <tr>
              <th width="120">图片根路径：</th>
              <td>mageRootPath
              </td>
              <th width="100">系统语言：</th>
              <td>zh_cn</td>
            </tr>

            <tr>
              <th>是否开放网站：</th>
              <td>
                开放
                关闭
              </td>
              <th>编码：</th>
              <td>UTF-8</td>
            </tr>
            <tr>
              <th>联系地址：</th>
              <td>Address
              </td>
              <th>传真：</th>
              <td>Fax
              </td>
            </tr>
            <tr>
              <th>联系手机：</th>
              <td>Phone
              </td>
              <th>联系电话：</th>
              <td>Tel
              </td>
            </tr>
            <tr>
              <th>邮箱：</th>
              <td>Email
              </td>
              <th>备案号：</th>
              <td>Icp
              </td>
            </tr>
            <tr>
              <th>网站关闭信息：</th>
              <td colspan="3">
                CloseMsg
              </td>
            </tr>
          </table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>最新留言</span>
          </div>
          <table width="100%" border="0" cellspacing="0" cellpadding="7" class="tableBasic">
            <tr>
              <th width="45%" style="text-align: center;">留言标题</th>
              <th width="15%" style="text-align: center;">留言人</th>
              <th width="30%" style="text-align: center;">留言时间</th>
            </tr>
              <tr>
                <td align="center">${item.title}</td>
                <td align="center">${item.name}</td>
                <td align="center">${item.leavetime}</td>
              </tr>
          </table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "Overview"
    }
</script>

<style scoped>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 800px;
  }
  .tableBasic {
    background-color: #F9F9F9;
    color: #666666;
    border-left: 1px dotted #CCCCCC;
    border-top: 1px dotted #CCCCCC;
  }

  .tableBasic td, .tableBasic th {
    border-right: 1px dotted #CCCCCC;
    border-bottom: 1px dotted #CCCCCC;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/Overview.vue